import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import {useHistory} from "react-router-dom";
import * as actions from '../../actions/CustomersEntityTableActions';
import * as columnFormatters from '../../../_common/column-formatters';
import * as customColumnFormatters from '../column-formatters';
import {useCustomersEntityUIContext} from '../CustomersEntityUIContext';
import useInfiniteScrollControl from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from '../../../_common/components/CommonGrid';
import CommonGridSpinner from '../../../_common/components/CommonGridSpinner';
import SortingColumnHeader from "../../../_common/components/SortingColumnHeader/SortingColumnHeader";

export default function CustomersEntityTable() {
  const {formatMessage} = useIntl();
  const history = useHistory();
  const [tableRows, setTableRows] = useState([]);
  const prefix = 'customers-entity-column';
  const columns = useMemo(() => [
    {
      accessor: 'customerID',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-customerID`, defaultMessage: 'Customer ID'})}
          fieldName={'customerID'}
          useContext={useCustomersEntityUIContext}
          showDefaultIcon={true}
        />
    },
    {
      accessor: 'fullName',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-full-name`, defaultMessage: 'Name'})}
          fieldName={'fullName'}
          useContext={useCustomersEntityUIContext}
        />
    },
    {
      accessor: 'phone',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-phone`, defaultMessage: 'Phone'})}
          fieldName={'phone'}
          useContext={useCustomersEntityUIContext}
        />
    },
    {
      accessor: 'email',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-email`, defaultMessage: 'Email'})}
          fieldName={'email'}
          useContext={useCustomersEntityUIContext}
        />
    },
    {
      accessor: 'customerTypeName',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-customer-type`, defaultMessage: 'Customer type'})}
          fieldName={'customerTypeName'}
          useContext={useCustomersEntityUIContext}
        />
    },
    {
      accessor: 'idNumber',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-id-number`, defaultMessage: 'ID number'})}
          fieldName={'idNumber'}
          useContext={useCustomersEntityUIContext}
        />
    },
    {
      accessor: 'customerStatus',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-customerStatus`, defaultMessage: 'Status'})}
          fieldName={'customerStatus'}
          useContext={useCustomersEntityUIContext}
        />
    },
    {
      accessor: 'actions',
      Header: '',
      width: 90
    },
  ], []);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        customerID: customColumnFormatters.CustomerIdColumnFormatter(item.customerID, item.greenInvoiceClientID),
        fullName: columnFormatters.BoldColumnFormatter([item.firstName, item.lastName].filter(Boolean).join(' ')),
        phone: columnFormatters.BoldColumnFormatter(item.phone),
        email: columnFormatters.BoldLTRColumnFormatter(item.email),
        customerTypeName: customColumnFormatters.TypeColumnFormatter(item),
        idNumber: columnFormatters.BoldColumnFormatter(item.idNumber),
        customerStatus: customColumnFormatters.StatusColumnFormatter(item),
        actions: customColumnFormatters.CustomersActionsColumnFormatter(item, {history}),
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'customersEntityTableReducer',
    UIContext: useCustomersEntityUIContext(),
    getNewEntities: actions.getCustomers,
    getNextEntities: actions.getNextCustomers,
    onEntitiesChange: entities => {
      entities
        ? setTableRows(entities)
        : setTableRows([]);
    },
    startRequestedPageNumber: 0,
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <CommonGridSpinner/>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      {...useTable({columns, data})}
    />
  );
}
